import { GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useContext, useEffect } from 'react';
import LoginScreen from '@/components/login/LoginScreen';
import SocialMetaTags from '@/components/SocialMetaTags';
import { CART_TYPE } from '@/constants/cart';
import { ACCESS_TOKEN_KEY, MY_CART, VENDOR_ID_COOKIE_NAME } from '@/constants/common';
import { AuthContext } from '@/context/AuthProvider';
import { UserContext } from '@/context/UserProvider';
import { CartStateInStorage, PriceInStorage } from '@/models/Product';
import createCart from '@/utils/api/createCart';
import { updateCartIdInLocalStorage } from '@/utils/cart';
import { getCookieValue, getLocalStorageKey, postMessageToWebView, removeLocalStorageKey } from '@/utils/helper';
interface Props {
  title: string;
}
const LoginPage = ({
  title
}: Props) => {
  const {
    t
  } = useTranslation('common');
  const {
    reload
  } = useRouter();
  const {
    isAuthenticated
  } = useContext(AuthContext);
  const {
    user
  } = useContext(UserContext);
  useEffect(() => {
    if ('ReactNativeWebView' in window) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      postMessageToWebView(window, {
        code: 'ERR_001',
        message: 'logout'
      });
    }
  }, []);
  const updateCartAfterLogin = async () => {
    if (isAuthenticated) {
      const vendorInCookie = getCookieValue(VENDOR_ID_COOKIE_NAME);
      if (user?.cart_id) updateCartIdInLocalStorage(user.cart_id);
      const cartData = getLocalStorageKey<CartStateInStorage, null>(MY_CART, null);
      const priceData = getLocalStorageKey<PriceInStorage, PriceInStorage>('pp_d', {}) || {};
      const dehaatCart = cartData?.[CART_TYPE.DEHAAT];
      const items = {
        ...(dehaatCart?.items ?? {})
      };
      const catalogueIds = {
        ...(dehaatCart?.catalogueIds ?? {})
      };
      const cartItems: Record<string, number> = {
        ...(items as any)
      };
      const itemKeys = Object.keys(cartItems);
      const priceKeys = Object.keys(priceData);
      if (itemKeys.length > 0 && priceKeys.length >= itemKeys.length) {
        const productDetails = itemKeys.map(key => {
          const localPrice = priceData[key];
          return {
            product_variant: Number(key),
            quantity: cartItems[key] || 0,
            c_id: catalogueIds[key],
            price: localPrice?.price ?? 0,
            discount: localPrice?.discount ?? 0
          };
        });
        createCart({
          vendor: vendorInCookie,
          product_details: productDetails,
          is_login_request: true,
          cart_id: user?.cart_id || ''
        });
        removeLocalStorageKey('pp_d');
      }
    }
    reload();
  };
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="login.tsx">
        <meta name="title" content={title} data-sentry-element="meta" data-sentry-source-file="login.tsx" />
        <meta name="description" content={t('app_description')} data-sentry-element="meta" data-sentry-source-file="login.tsx" />
      </Head>
      <SocialMetaTags title={title} description={t('app_description')} data-sentry-element="SocialMetaTags" data-sentry-source-file="login.tsx" />
      <LoginScreen onLogin={updateCartAfterLogin} data-sentry-element="LoginScreen" data-sentry-source-file="login.tsx" />
    </>;
};
export async function getServerSideProps({
  req: {
    cookies
  }
}: GetServerSidePropsContext) {
  const accessToken = cookies[ACCESS_TOKEN_KEY];
  if (accessToken != null) {
    return {
      redirect: {
        destination: '/',
        permanent: false
      }
    };
  }
  return {
    props: {
      title: 'DeHaat Kisan App: Login page'
    }
  };
}
export default LoginPage;